<script>
import ScrollLoader from 'vue-infinite-loading'

export default {
  name: 'ScrollingTableBody',
  components: { ScrollLoader },
  props: {
    rows: {
      default: null,
      type: Array,
    },
    isInfinitelyScrolling: {
      default: false,
      type: Boolean,
    },
    callback: {
      default: function() {},
      type: Function,
    },
  },
  methods: {
    scrolling($state) {
      var continueScrolling = this.callback()

      if (continueScrolling) {
        $state.loaded()
      } else {
        $state.complete()
      }
    },
  },
}
</script>

<template>
  <div :class="$style.table_container">
    <table :class="$style.table">
      <tbody>
        <tr v-for="row in rows" :key="row.value" :value="row.value">
          <td
            v-for="column in row"
            :key="column.value"
            :value="column.value"
            :class="$style.table_column"
            :style="column.style"
          >
            {{ column.value }}
          </td>
        </tr>
      </tbody>
      <ScrollLoader v-if="isInfinitelyScrolling" @infinite="scrolling">
        <div slot="spinner" class="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </ScrollLoader>
    </table>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.table_container {
  width: 100%;
  margin: auto;
}

.table {
  table-layout: fixed;
  width: 100%;
  border-spacing: 0.25em;
  z-index: 1;
  position: relative;
  top: inherit;
  text-align: center;
}

.table_column {
  text-align: center;
  word-wrap: break-word;
  padding: 0.5em 0;
}

tr:nth-child(even) {
  background-color: $color-table-row;
}
</style>
